import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function ImportantNotes() {
  return (
    <Box
      sx={{
        p: 3.5,
        borderRadius: "14px",
        background: "rgba(255, 255, 255, 0.85)",
        backdropFilter: "blur(6px)",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 6px 24px rgba(0, 0, 0, 0.05)",
        maxWidth: "1200px",
        margin: "35px auto",
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Box
          sx={{
            width: "34px",
            height: "34px",
            borderRadius: "8px",
            backgroundColor: "rgba(25,118,210,0.15)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mr: 1.5,
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 20, color: "primary.main" }} />
        </Box>

        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "17px",
            color: "#0a0e27",
          }}
        >
          Important Notes
        </Typography>
      </Box>

      {/* Bullet List */}
      <Box sx={{ pl: 1, mt: 1 }}>
        <Typography
          sx={{
            mb: 1.2,
            color: "#475569",
            fontSize: "14.2px",
            lineHeight: 1.65,
            display: "flex",
          }}
        >
          <span style={{ fontWeight: "bold", marginRight: "8px" }}>•</span>
          The platform does&nbsp;<strong>NOT</strong>&nbsp;provide logistics
          services. All shipping responsibilities fall on the Buyer or Seller.
        </Typography>

        <Typography
          sx={{
            mb: 1.2,
            color: "#475569",
            fontSize: "14.2px",
            lineHeight: 1.65,
            display: "flex",
          }}
        >
          <span style={{ fontWeight: "bold", marginRight: "8px" }}>•</span>
          Pickup and Delivery notes are essential for smooth operations. Please
          provide clear and detailed instructions.
        </Typography>

        <Typography
          sx={{
            color: "#475569",
            fontSize: "14.2px",
            lineHeight: 1.65,
            display: "flex",
          }}
        >
          <span style={{ fontWeight: "bold", marginRight: "8px" }}>•</span>
          All fields marked with&nbsp;<strong>*</strong>&nbsp;are mandatory.
          Please complete them before submission.
        </Typography>
      </Box>
    </Box>
  );
}
